import { connect } from 'react-redux'
import AddToHomeModal from './AddToHomeModal'
import { markAsComplete } from '../AddToHome.actions'

const stateToProps = () => ({})

const dispatchToProps = {
  markAsComplete,
}

export default connect(stateToProps, dispatchToProps)(AddToHomeModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/AddToHome/AddToHomeModal/AddToHomeModal.container.js